module.exports = __webpack_public_path__ + "media/images/closed-eye-c3e775e8269754dfeea63237a3b1c9b6.svg";